export default __webpack_public_path__ + "resources/icons/n341-a02d.webp";